import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-5 px-6 bg-midnight-light border-t border-gold/10 pt-[50px] pb-[50px]" data-id="element-73">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 1
    }} className="max-w-2xl mx-auto text-center" data-id="element-74">
        <ShieldCheck className="w-10 h-10 text-gold mx-auto mb-3" strokeWidth={1} data-id="element-75" />

        <h2 className="font-cinzel text-2xl md:text-3xl text-white tracking-[0.1em] mb-3" data-id="element-76">
          GARANTÍA DE <span className="text-gold" data-id="element-77">SOBERANÍA</span>
        </h2>

        <p className="font-sans text-sm text-gray-400 font-light leading-loose mb-4 max-w-lg mx-auto" data-id="element-78">
          Si en 7 días no sentís que recuperaste el mando de tu vida, te
          devolvemos el 100% sin preguntas. Sin formularios. Sin humillación. Tu
          palabra es suficiente.
        </p>

        <div className="inline-block border border-gold/20 px-8 py-4" data-id="element-79">
          <p className="font-sans text-[10px] text-gold tracking-[0.2em] uppercase" data-id="element-80">
            7 días • Reembolso total • Sin preguntas
          </p>
        </div>
      </motion.div>
    </section>;
}